import Link from 'next/link'
import { useId } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'
import { IR_TOP_ROUTE } from '@/utils/routes'

import { Button } from '@/components/elements/Button'

const stockPriceLink = IR_TOP_ROUTE.subdirectories[4].path

export const StockPriceInfoCard = () => {
  const id = useId()

  return (
    <Card>
      <Title id={id}>株価情報</Title>
      <Iframe
        id="irpocket-stock-board-pc"
        src="//irpocket.com/stock-chart/141As.html"
        height="150"
        aria-labelledby={id}
      ></Iframe>
      {/* <Iframe
        id="irpocket-stock-board-pc"
        src="//irpocket.com/stock-chart/5882s.html"
        height="150"
        aria-labelledby={id}
      ></Iframe> */}
      <Link href={stockPriceLink} passHref>
        <a>
          <LinkButton btnStyle="transparent">株価チャート</LinkButton>
        </a>
      </Link>
    </Card>
  )
}

const Card = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 22px 20px;
  gap: 10px;
  background: ${theme.colors.backgroundGrey};
  border-radius: 8px;
`

const Iframe = styled.iframe`
  width: 100%;
`

const Title = styled.h2`
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  padding: 0px 0px 12px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid ${theme.colors.grey};
  @media screen and (max-width: 1047px) {
    font-size: 20px;
  }
`

const LinkButton = styled(Button)`
  width: 200px;
  height: 42px;
  padding: 7px 26px 9px;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  background-color: #ffffff;

  @media screen and (max-width: 1047px) {
    width: 295px;
    height: 42px;
  }
`
